const chooseUsHeader = {
    heading: "Why Choose Us?",
    desc: `Rest assured, your project is in capable hands with AVR Labs.`
}

export default chooseUsHeader;